import React from "react"
import { connect } from "react-redux"
import _ from "../../utils/lodashUtils"
import "./ChooseRestaurant.scss"
import { PARTNER_ADDRESS_PENDING } from "../../constants/messages"
import { TextTag } from "../../atoms"
import { FirebaseContext } from "../../firebase"
import { getPartnerNameorNickName } from "../../utils/helpers"

const WaitingForPartnerHeader = (props) => {
  const { partner } = props
  const { partnerState } = React.useContext(FirebaseContext)
  let gender = ""
  gender =
    _.get(partner, "gender") === "MALE"
      ? " his"
      : _.get(partner, "gender") === "FEMALE"
      ? " her"
      : " their"
  return (
    <div id="WaitingForPartnerHeader">
      <div id="dinnerPlan">
        <div id="dinnerPlanHeading">
          <TextTag>
            {PARTNER_ADDRESS_PENDING(
              getPartnerNameorNickName(partnerState, partner),
              gender
            )}
          </TextTag>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    partner: _.get(state, "auth.partner", {}),
    partnerDetails: state.invitePeople.partnerDetails,
  }
}

export default connect(mapStateToProps, {})(WaitingForPartnerHeader)
